import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import AppConst from '../apis/appconst';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from 'react-select';
import BalanceSheet from './BalanceSheet'; // ← NEW IMPORT (adjust path if needed)
import IpdNetCollection from './IpdNetCollection'; // ← NEW IMPORT

function Daybook() {
    // ========== TAB STATE ==========
    const [activeTab, setActiveTab] = useState('transactions'); // 'transactions' | 'balance' | 'ipd_net'
    const [balanceCount, setBalanceCount] = useState(0); // received from BalanceSheet child
    const [ipdNetCount, setIpdNetCount] = useState(0); // received from IpdNetCollection child
    const [fromTime, setFromTime] = useState('');
    const [toTime, setToTime] = useState('');
    // ========== ORIGINAL DAYBOOK STATE ==========
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totals, setTotals] = useState({ cash: 0, card: 0, online: 0, total: 0 });
    const [departmentTotals, setDepartmentTotals] = useState({});

    const [expensesTotal, setExpensesTotal] = useState(0);
    const [netAmount, setNetAmount] = useState(0);

    const [returnTotals, setReturnTotals] = useState({
        pharmacy_returns: 0,
        ipd_returns: 0,
        lab_refunds: 0,
        opd_refunds: 0,
        total_returns: 0,
        net_collection: 0
    });
    const [users, setUsers] = useState([]);

    
    const getLocalToday = () => {
        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    
    const [fromDate, setFromDate] = useState(getLocalToday());
    const [toDate, setToDate] = useState(getLocalToday());

    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedPaymentModes, setSelectedPaymentModes] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const departmentOptions = [
        { value: 'ipd_reg', label: 'IPD Registration' },
        { value: 'ipd', label: 'IPD Billing' },
        { value: 'ipd_advance', label: 'IPD Advance' },
        { value: 'opd', label: 'OPD' },
        { value: 'opd_procedure', label: 'Procedure' },
        { value: 'emergency', label: 'Emergency' },
        { value: 'lab', label: 'Lab' },
        { value: 'pharmacy', label: 'Pharmacy' },
    ];

    const paymentModeOptions = [
        { value: 'Cash', label: 'Cash' },
        { value: 'Card', label: 'Card' },
        { value: 'Online', label: 'Online' },
    ];


    // custom (non-bootstrap) badge colors
    const CUSTOM_BADGE = {
        procedure: { background: '#fd7e14', color: '#fff' }, // purple
    };
    // Fixed department order (same as your summary badges)
const DEPT_ORDER = [
    { key: 'ipd_reg',        label: 'IPD Reg',    color: 'primary' },
    { key: 'ipd',            label: 'IPD Bill',   color: 'primary' },
    { key: 'ipd_advance',    label: 'IPD Adv',    color: 'info' },
    { key: 'opd',            label: 'OPD',        color: 'success' },
    { key: 'opd_procedure',  label: 'Procedure',  color: 'procedure' },
    { key: 'emergency',      label: 'Emergency',  color: 'danger' },
    { key: 'lab',            label: 'Lab',        color: 'warning' },
    { key: 'pharmacy',       label: 'Pharmacy',   color: 'secondary' },
    { key: 'pharmacy_return',label: 'Pharma Ret', color: 'danger', isNegative: true },
    { key: 'ipd_return',     label: 'IPD Refund', color: 'danger', isNegative: true },
    { key: 'lab_refund',     label: 'Lab Refund', color: 'danger', isNegative: true },
    { key: 'opd_refund',     label: 'OPD Refund', color: 'danger', isNegative: true },
];

// Split one transaction into cash/card/online buckets (same logic as filteredTotals)
const getModeAmounts = (trx) => {
    const amount = Number(trx.payment_amount || 0);
    if (typeof trx.cash !== 'undefined' || typeof trx.card !== 'undefined' || typeof trx.online !== 'undefined') {
        return { cash: Number(trx.cash || 0), card: Number(trx.card || 0), online: Number(trx.online || 0) };
    }
    const mode = (trx.payment_mode || '').toLowerCase();
    if (mode.includes('card')) return { cash: 0, card: amount, online: 0 };
    if (mode.includes('online') || mode.includes('upi')) return { cash: 0, card: 0, online: amount };
    return { cash: amount, card: 0, online: 0 };
};


    const userOptions = useMemo(() => {
        return users.map(u => ({
            value: u.user_id,
            label: u.fname + (u.lname ? ' ' + u.lname : '')
        }));
    }, [users]);
    const toMinutes = (timeStr) => {
        if (!timeStr) return null;
        const parts = String(timeStr).split(':');
        if (parts.length < 2) return null;
        const h = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        if (isNaN(h) || isNaN(m)) return null;
        return h * 60 + m;
    };
    const reactSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '31px',
            fontSize: '13px',
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
            '&:hover': { borderColor: '#86b7fe' },
        }),
        valueContainer: (base) => ({ ...base, padding: '0 6px' }),
        multiValue: (base) => ({ ...base, backgroundColor: '#e7f1ff', borderRadius: '3px', fontSize: '12px' }),
        multiValueLabel: (base) => ({ ...base, color: '#0d6efd', padding: '1px 4px', fontSize: '12px' }),
        multiValueRemove: (base) => ({
            ...base, color: '#0d6efd',
            ':hover': { backgroundColor: '#0d6efd', color: 'white' },
        }),
        placeholder: (base) => ({ ...base, color: '#6c757d', fontSize: '13px' }),
        menu: (base) => ({ ...base, zIndex: 9999, fontSize: '13px' }),
        option: (base, state) => ({
            ...base, fontSize: '13px', padding: '6px 10px',
            backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e7f1ff' : 'white',
            color: state.isSelected ? 'white' : '#212529',
        }),
        indicatorsContainer: (base) => ({ ...base, height: '31px' }),
        dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
        clearIndicator: (base) => ({ ...base, padding: '4px' }),
    };

    const fetchTransactions = useCallback(async () => {
        setIsLoading(true);
        try {
            const fd = new FormData();
            fd.append('from_date', fromDate);
            fd.append('to_date', toDate);

            if (selectedDepartments.length === 0) {
                fd.append('department', 'all');
            } else {
                fd.append('department', selectedDepartments.map(d => d.value).join(','));
            }

            if (selectedPaymentModes.length === 0) {
                fd.append('payment_mode', 'all');
            } else {
                fd.append('payment_mode', selectedPaymentModes.map(m => m.value).join(','));
            }

            if (selectedUsers.length === 0) {
                fd.append('user_id', 'all');
            } else {
                fd.append('user_id', selectedUsers.map(u => u.value).join(','));
            }

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getDaybookTransactionsUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response?.data?.status) {
                setTransactions(response.data.transactions || []);
                setTotals(response.data.totals || { cash: 0, card: 0, online: 0, total: 0 });
                setDepartmentTotals(response.data.department_totals || {});
                setUsers(response.data.users || []);
                setReturnTotals(response.data.return_totals || {
                    pharmacy_returns: 0, ipd_returns: 0, lab_refunds: 0, opd_refunds: 0,
                    total_returns: 0, net_collection: 0
                });
                setExpensesTotal(Number(response.data.expenses_total || 0));   // ✅
                setNetAmount(Number(response.data.net_amount || 0));           // ✅
            } else {
                toast.error(response?.data?.message || 'Failed to fetch transactions');
                setTransactions([]);
            }
        } catch (error) {
            console.error('Fetch daybook error:', error);
            toast.error('Failed to fetch transactions');
            setTransactions([]);
        } finally {
            setIsLoading(false);
        }
    }, [fromDate, toDate, selectedDepartments, selectedPaymentModes, selectedUsers]);

    // Only fetch transactions when on transactions tab
    useEffect(() => {
        if (activeTab === 'transactions') {
            fetchTransactions();
        }
    }, [activeTab, fetchTransactions]);

    const handleSearch = () => fetchTransactions();
    const handleClearSearch = () => setSearchKey('');

    const filteredTransactions = useMemo(() => {
        let result = transactions;
    
        // time filter
        const fromMin = toMinutes(fromTime);
        const toMin = toMinutes(toTime);
        if (fromMin !== null || toMin !== null) {
            result = result.filter(trx => {
                const t = toMinutes(trx.payment_time);
                if (t === null) return false;
                if (fromMin !== null && t < fromMin) return false;
                if (toMin !== null && t > toMin) return false;
                return true;
            });
        }
    
        // search filter
        if (searchKey.trim()) {
            const search = searchKey.toLowerCase();
            result = result.filter(trx =>
                (trx.uhid || '').toLowerCase().includes(search) ||
                (trx.patient_name || '').toLowerCase().includes(search) ||
                (trx.received_by_name || '').toLowerCase().includes(search) ||
                (trx.department || '').toLowerCase().includes(search) ||
                (trx.transaction_id || '').toLowerCase().includes(search)
            );
        }
    
        return result;
    }, [transactions, searchKey, fromTime, toTime]);


    const filteredTotals = useMemo(() => {
        if (!searchKey.trim()) return totals;
        return filteredTransactions.reduce((acc, trx) => {
            const amount = Number(trx.payment_amount || 0);
            acc.total += amount;
            if (typeof trx.cash !== 'undefined' || typeof trx.card !== 'undefined' || typeof trx.online !== 'undefined') {
                acc.cash += Number(trx.cash || 0);
                acc.card += Number(trx.card || 0);
                acc.online += Number(trx.online || 0);
                return acc;
            }
            const mode = (trx.payment_mode || '').toLowerCase();
            if (mode.includes('cash')) acc.cash += amount;
            else if (mode.includes('card')) acc.card += amount;
            else if (mode.includes('online') || mode.includes('upi')) acc.online += amount;
            else acc.cash += amount;
            return acc;
        }, { cash: 0, card: 0, online: 0, total: 0 });
    }, [filteredTransactions, searchKey, fromTime, toTime, totals]);

    const filteredDepartmentTotals = useMemo(() => {
        if (!searchKey.trim()) return departmentTotals;
        return filteredTransactions.reduce((acc, trx) => {
            const dept = trx.dept_key || '';
            const amount = Number(trx.payment_amount || 0);
            if (dept && amount > 0) {
                acc[dept] = (acc[dept] || 0) + amount;
            }
            return acc;
        }, {});
    }, [filteredTransactions, searchKey, fromTime, toTime, departmentTotals]);



    const groupedTransactions = useMemo(() => {
        const map = {};
        filteredTransactions.forEach(trx => {
            const key = trx.dept_key || 'other';
            (map[key] = map[key] || []).push(trx);
        });
    
        const known = new Set(DEPT_ORDER.map(d => d.key));
        const ordered = DEPT_ORDER
            .filter(d => map[d.key] && map[d.key].length)
            .map(d => ({ ...d, rows: map[d.key] }));
    
        // any dept_key not in DEPT_ORDER goes to the end
        Object.keys(map).forEach(k => {
            if (!known.has(k)) ordered.push({ key: k, label: k, color: 'dark', rows: map[k] });
        });
    
        // per-group subtotal
        return ordered.map(g => {
            const sub = g.rows.reduce((a, t) => {
                const m = getModeAmounts(t);
                a.cash += m.cash; a.card += m.card; a.online += m.online;
                a.total += Number(t.payment_amount || 0);
                return a;
            }, { cash: 0, card: 0, online: 0, total: 0 });
            return { ...g, sub };
        });
    }, [filteredTransactions]);

    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
    
        // Pull just the date part if a datetime came through ("2026-08-28 00:17:00")
        const datePart = String(dateStr).trim().split(/[ T]/)[0];
        const m = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    
        let date;
        if (m) {
            // Build as LOCAL date — no UTC shift
            date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        } else {
            date = new Date(dateStr);
        }
        if (isNaN(date)) return dateStr;
    
        return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) return '';
        try {
            const parts = timeStr.split(':');
            if (parts.length < 2) return timeStr;
            const h = parseInt(parts[0]);
            const m = parts[1];
            const ampm = h >= 12 ? 'PM' : 'AM';
            return `${h % 12 || 12}:${m} ${ampm}`;
        } catch { return timeStr; }
    };

    const getDeptBadgeClass = (dept) => {
        const classes = {
            'IPD Billing': 'bg-primary',
            'IPD Advance': 'bg-info',
            'IPD Refund': 'bg-danger',
            'OPD': 'bg-success',
            // 'OPD Procedure': 'bg-success',
            'Procedure': 'bg-success',
            'OPD Refund': 'bg-danger',
            'Emergency': 'bg-danger',
            'Lab': 'bg-warning text-dark',
            'Lab Payment': 'bg-warning text-dark',
            'Lab Refund': 'bg-danger',
            'Pharmacy': 'bg-secondary',
            'Pharmacy Payment': 'bg-secondary',
            'Pharmacy Return': 'bg-danger'
        };
        return classes[dept] || 'bg-dark';
    };

    const getPaymentModeBadge = (mode) => {
        const m = (mode || '').toLowerCase();
        if (m.includes('cash')) return <span className="badge bg-success">Cash</span>;
        if (m.includes('card')) return <span className="badge bg-primary">Card</span>;
        if (m.includes('online') || m.includes('upi')) return <span className="badge bg-info">Online</span>;
        return <span className="badge bg-secondary">{mode || 'Cash'}</span>;
    };

    const handlePrintPDF = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
    
        doc.setFontSize(16).setFont('helvetica', 'bold');
        doc.text('DAYBOOK REPORT', pageWidth / 2, 15, { align: 'center' });
        doc.setFontSize(10).setFont('helvetica', 'normal');
        doc.text(`Date: ${formatDate(fromDate)} to ${formatDate(toDate)}`, pageWidth / 2, 22, { align: 'center' });
    
        let startY = 30;
    
        groupedTransactions.forEach(group => {
            // new page if not enough room for header + a couple rows
            if (startY > pageHeight - 40) { doc.addPage(); startY = 20; }
    
            // section header
            doc.setFontSize(11).setFont('helvetica', 'bold');
            doc.text(group.label, 14, startY);
    
            const body = group.rows.map((trx, idx) => [
                idx + 1,
                trx.uhid || 'N/A',
                (trx.patient_name || 'N/A').substring(0, 20),
                formatDate(trx.payment_date),
                formatTime(trx.payment_time),
                trx.payment_mode || 'Cash',
                `${Number(trx.payment_amount || 0) < 0 ? '- ' : ''}Rs.${Math.abs(Number(trx.payment_amount || 0)).toFixed(2)}`,
                (trx.received_by_name || 'N/A').substring(0, 14)
            ]);
    
            autoTable(doc, {
                startY: startY + 2,
                head: [['#', 'UHID', 'Patient', 'Date', 'Time', 'Mode', 'Amount', 'Received']],
                body,
                theme: 'grid',
                headStyles: { fillColor: [64, 81, 137], fontSize: 8 },
                styles: { fontSize: 7, cellPadding: 1.5 },
                columnStyles: { 6: { halign: 'right' } }
            });
    
            // per-department summary (cash / card / online / subtotal)
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 1,
                body: [[
                    `${group.label} Summary`,
                    `Cash Rs.${group.sub.cash.toFixed(2)}`,
                    `Card Rs.${group.sub.card.toFixed(2)}`,
                    `Online Rs.${group.sub.online.toFixed(2)}`,
                    `Subtotal Rs.${group.sub.total.toFixed(2)}`
                ]],
                theme: 'grid',
                styles: { fontSize: 8, fontStyle: 'bold', fillColor: [240, 240, 240] },
                columnStyles: { 4: { halign: 'right' } }
            });
    
            startY = doc.lastAutoTable.finalY + 8;
        });
    
        // grand total
        if (startY > pageHeight - 45) { doc.addPage(); startY = 20; }
        doc.setFontSize(12).setFont('helvetica', 'bold');
        doc.text('GRAND TOTAL', 14, startY);
        autoTable(doc, {
            startY: startY + 3,
            body: [
                ['Cash', `Rs.${filteredTotals.cash.toFixed(2)}`],
                ['Card', `Rs.${filteredTotals.card.toFixed(2)}`],
                ['Online', `Rs.${filteredTotals.online.toFixed(2)}`],
                ['TOTAL', `Rs.${filteredTotals.total.toFixed(2)}`]
            ],
            theme: 'grid',
            styles: { fontSize: 10 },
            columnStyles: { 1: { halign: 'right' } },
            margin: { left: 14 }
        });
    


                // Expenses + Net Amount
                startY = doc.lastAutoTable.finalY + 6;
                autoTable(doc, {
                    startY,
                    body: [
                        ['Total Collection', `Rs.${filteredTotals.total.toFixed(2)}`],
                        ['Total Expenses', `- Rs.${Number(expensesTotal).toFixed(2)}`],
                        ['NET AMOUNT (IN HAND)', `Rs.${Number(filteredTotals.total - expensesTotal).toFixed(2)}`]
                    ],
                    theme: 'grid',
                    styles: { fontSize: 10, fontStyle: 'bold' },
                    columnStyles: { 1: { halign: 'right' } },
                    margin: { left: 14 }
                });
        const pdfBlob = doc.output('blob');
        window.open(URL.createObjectURL(pdfBlob), '_blank');
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 style={{ color: '#405189' }}>
                        <i className="ri-book-2-line me-2"></i>Daybook
                    </h4>
                    {activeTab === 'transactions' && (
                        <button className="btn btn-primary btn-sm" onClick={handlePrintPDF}>
                            <i className="ri-printer-line me-1"></i> Print
                        </button>
                    )}
                </div>

                {/* TABS */}
                <ul className="nav nav-tabs mb-3" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'transactions' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('transactions')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-exchange-line me-1"></i>
                            All Transactions
                            {activeTab === 'transactions' && (
                                <span className="badge bg-primary ms-2">{filteredTransactions.length}</span>
                            )}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'balance' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('balance')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-hand-coin-line me-1"></i>
                            Balance Sheet
                            {balanceCount > 0 && (
                                <span className="badge bg-danger ms-2">{balanceCount}</span>
                            )}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'ipd_net' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('ipd_net')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-hospital-line me-1"></i>
                            IPD Net Collection
                            {activeTab === 'ipd_net' && ipdNetCount > 0 && (
                                <span className="badge bg-info ms-2">{ipdNetCount}</span>
                            )}
                        </button>
                    </li>
                </ul>

                {/* ============================================ */}
                {/* TAB 1: ALL TRANSACTIONS                       */}
                {/* ============================================ */}
                {activeTab === 'transactions' && (
                    <>
                        {/* Filters */}
                        <div className="card mb-3">
                            <div className="card-body py-2">
                                <div className="row g-2 align-items-end">
                                <div className="col-lg-2 col-md-4 col-6">
    <label className="form-label small mb-1">From</label>
    <input type="date" className="form-control form-control-sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
</div>
<div className="col-lg-2 col-md-4 col-6">
    <label className="form-label small mb-1">To</label>
    <input type="date" className="form-control form-control-sm" value={toDate} onChange={(e) => setToDate(e.target.value)} />
</div>

{/* NEW: time filters */}
<div className="col-lg-1 col-md-4 col-6">
    <label className="form-label small mb-1">From Time</label>
    <input type="time" className="form-control form-control-sm" value={fromTime} onChange={(e) => setFromTime(e.target.value)} />
</div>
<div className="col-lg-1 col-md-4 col-6">
    <label className="form-label small mb-1">To Time</label>
    <input type="time" className="form-control form-control-sm" value={toTime} onChange={(e) => setToTime(e.target.value)} />
</div>

                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label className="form-label small mb-1">Department</label>
                                        <Select
                                            isMulti
                                            options={departmentOptions}
                                            value={selectedDepartments}
                                            onChange={(selected) => setSelectedDepartments(selected || [])}
                                            placeholder="All Departments"
                                            isClearable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>

                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label className="form-label small mb-1">Mode</label>
                                        <Select
                                            isMulti
                                            options={paymentModeOptions}
                                            value={selectedPaymentModes}
                                            onChange={(selected) => setSelectedPaymentModes(selected || [])}
                                            placeholder="All Modes"
                                            isClearable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-6">
                                        <label className="form-label small mb-1">User</label>
                                        <Select
                                            isMulti
                                            options={userOptions}
                                            value={selectedUsers}
                                            onChange={(selected) => setSelectedUsers(selected || [])}
                                            placeholder="All Users"
                                            isClearable
                                            isSearchable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>

                                    <div className="col-lg-1 col-md-4 col-6">
                                        <button className="btn btn-primary btn-sm w-100" onClick={handleSearch} disabled={isLoading}>
                                            {isLoading ? <span className="spinner-border spinner-border-sm"></span> : <><i className="ri-search-line me-1"></i>Search</>}
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">
                                                <i className="ri-search-line"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="🔍 Search by UHID, Patient Name, Department..."
                                                value={searchKey}
                                                onChange={(e) => setSearchKey(e.target.value)}
                                            />
                                            {searchKey && (
                                                <button className="btn btn-outline-secondary" type="button" onClick={handleClearSearch}>
                                                    <i className="ri-close-line"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex align-items-center">
                                        <small className="text-muted">
                                            {searchKey || selectedDepartments.length > 0 || selectedPaymentModes.length > 0 || selectedUsers.length > 0 ? (
                                                <>Showing <strong>{filteredTransactions.length}</strong> of <strong>{transactions.length}</strong> transactions</>
                                            ) : (
                                                <><strong>{filteredTransactions.length}</strong> transactions</>
                                            )}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Summary Cards */}
                        <div className="row mb-3 g-2">
                            <div className="col-md-3 col-6">
                                <div className="card border-success h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Cash</small>
                                        <h5 className="text-success mb-0">₹{filteredTotals.cash.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card border-primary h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Card</small>
                                        <h5 className="text-primary mb-0">₹{filteredTotals.card.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card border-info h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Online</small>
                                        <h5 className="text-info mb-0">₹{filteredTotals.online.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card bg-primary text-white h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-white-50">Total</small>
                                        <h5 className="text-white mb-0">₹{filteredTotals.total.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Department Summary */}
                        <div className="card mb-3">
                            <div className="card-body py-2">
                                <div className="d-flex flex-wrap justify-content-around text-center gap-2">
                                    {[
                                        { key: 'ipd_reg', label: 'IPD Reg', color: 'primary' },
                                        { key: 'ipd', label: 'IPD Bill', color: 'primary' },
                                        { key: 'ipd_advance', label: 'IPD Adv', color: 'info' },
                                        { key: 'opd', label: 'OPD', color: 'success' },
                                        { key: 'opd_procedure', label: 'Procedure', color: 'procedure' },
                                        { key: 'emergency', label: 'Emergency', color: 'danger' },
                                        { key: 'lab', label: 'Lab', color: 'warning' },
                                        { key: 'pharmacy', label: 'Pharmacy', color: 'secondary' },
                                        { key: 'pharmacy_return', label: 'Pharma Ret', color: 'danger', isNegative: true },
                                        { key: 'ipd_return', label: 'IPD Refund', color: 'danger', isNegative: true },
                                        { key: 'lab_refund', label: 'Lab Refund', color: 'danger', isNegative: true },
                                        { key: 'opd_refund', label: 'OPD Refund', color: 'danger', isNegative: true }
                                    ].map(d => (
                                        <div key={d.key}>
                                        <span
                                            className={`badge ${CUSTOM_BADGE[d.color] ? '' : `bg-${d.color} ${d.color === 'warning' ? 'text-dark' : ''}`}`}
                                            style={{ fontSize: '10px', ...(CUSTOM_BADGE[d.color] || {}) }}
                                        >{d.label}</span>
                                            <div className={`small fw-bold ${d.isNegative ? 'text-danger' : ''}`}>
                                                {d.isNegative ? '- ' : ''}₹{Math.abs(filteredDepartmentTotals[d.key] || 0).toFixed(2)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Transactions Table */}
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                    <table className="table table-sm table-hover table-striped mb-0" style={{ fontSize: '11px' }}>
                                        <thead className="table-dark sticky-top">
                                            <tr>
                                                <th>#</th>
                                                <th>UHID</th>
                                                <th>Patient</th>
                                                <th>Dept</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Mode</th>
                                                <th className="text-end">Amount</th>
                                                <th>Received By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
    {isLoading ? (
        <tr><td colSpan="9" className="text-center py-3"><div className="spinner-border spinner-border-sm"></div></td></tr>
    ) : filteredTransactions.length === 0 ? (
        <tr><td colSpan="9" className="text-center py-3 text-muted">
            {searchKey ? `No transactions found for "${searchKey}"` : 'No transactions'}
        </td></tr>
    ) : (() => {
        let serial = 0;
        return groupedTransactions.map(group => (
            <React.Fragment key={group.key}>
                {/* group header */}
                <tr className="table-secondary">
                    <td colSpan="9" className="fw-bold">
                    <span
                            className={`badge me-2 ${CUSTOM_BADGE[group.color] ? '' : `bg-${group.color} ${group.color === 'warning' ? 'text-dark' : ''}`}`}
                            style={CUSTOM_BADGE[group.color] || {}}
                        >
                            {group.label}
                        </span>
                        {group.rows.length} entr{group.rows.length !== 1 ? 'ies' : 'y'}
                    </td>
                </tr>

                {/* group rows */}
                {group.rows.map((trx, i) => {
                    serial++;
                    return (
                        <tr key={trx.transaction_id || `${group.key}-${i}`}
                            style={trx.is_return || Number(trx.payment_amount) < 0 ? { backgroundColor: '#fff5f5' } : {}}>
                            <td>{serial}</td>
                            <td><strong className="text-primary">{trx.uhid || 'N/A'}</strong></td>
                            <td>{trx.patient_name || 'N/A'}</td>
                            <td>
                                {trx.department === 'Procedure' ? (
                                    <span className="badge" style={{ fontSize: '9px', ...CUSTOM_BADGE.procedure }}>
                                        {trx.department}
                                    </span>
                                ) : (
                                    <span className={`badge ${getDeptBadgeClass(trx.department)}`} style={{ fontSize: '9px' }}>
                                        {trx.department}
                                    </span>
                                )}
                            </td>
                            <td>{formatDate(trx.payment_date)}</td>
                            <td>{formatTime(trx.payment_time)}</td>
                            <td>{getPaymentModeBadge(trx.payment_mode)}</td>
                            <td className={`text-end fw-bold ${Number(trx.payment_amount) < 0 ? 'text-danger' : 'text-success'}`}>
                                {Number(trx.payment_amount) < 0 ? '- ' : ''}₹{Math.abs(Number(trx.payment_amount || 0)).toFixed(2)}
                            </td>
                            <td>{trx.received_by_name || 'N/A'}</td>
                        </tr>
                    );
                })}

                {/* group subtotal */}
                <tr className="table-light fw-bold">
                    <td colSpan="7" className="text-end">
                        {group.label} → Cash ₹{group.sub.cash.toFixed(2)} | Card ₹{group.sub.card.toFixed(2)} | Online ₹{group.sub.online.toFixed(2)} — Subtotal:
                    </td>
                    <td className={`text-end ${group.sub.total < 0 ? 'text-danger' : 'text-primary'}`}>
                        {group.sub.total < 0 ? '- ' : ''}₹{Math.abs(group.sub.total).toFixed(2)}
                    </td>
                    <td></td>
                </tr>
            </React.Fragment>
        ));
    })()}
</tbody>
{filteredTransactions.length > 0 && (
    <tfoot>
        <tr style={{ backgroundColor: '#405189', color: '#fff' }}>
            <td colSpan="7" className="text-end fw-bold" style={{ color: '#fff' }}>
                GRAND TOTAL → Cash ₹{filteredTotals.cash.toFixed(2)} | Card ₹{filteredTotals.card.toFixed(2)} | Online ₹{filteredTotals.online.toFixed(2)}
            </td>
            <td className="text-end fw-bold" style={{ color: '#fff' }}>
                ₹{filteredTotals.total.toFixed(2)}
            </td>
            <td style={{ backgroundColor: '#405189' }}></td>
        </tr>
    </tfoot>
)}
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Returns & Net Collection */}
                        {/* Individual refund cards — only when refunds exist */}
{(returnTotals.pharmacy_returns > 0 || returnTotals.ipd_returns > 0 ||
  returnTotals.lab_refunds > 0 || returnTotals.opd_refunds > 0) && (
    <div className="row mt-3 mb-3 g-2">
        {returnTotals.pharmacy_returns > 0 && (
            <div className="col-md-2 col-6">
                <div className="card border-danger h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-muted">Pharmacy Returns</small>
                        <h6 className="text-danger mb-0">- ₹{returnTotals.pharmacy_returns.toFixed(2)}</h6>
                    </div>
                </div>
            </div>
        )}
        {returnTotals.ipd_returns > 0 && (
            <div className="col-md-2 col-6">
                <div className="card border-danger h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-muted">IPD Refunds</small>
                        <h6 className="text-danger mb-0">- ₹{returnTotals.ipd_returns.toFixed(2)}</h6>
                    </div>
                </div>
            </div>
        )}
        {returnTotals.lab_refunds > 0 && (
            <div className="col-md-2 col-6">
                <div className="card border-danger h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-muted">Lab Refunds</small>
                        <h6 className="text-danger mb-0">- ₹{returnTotals.lab_refunds.toFixed(2)}</h6>
                    </div>
                </div>
            </div>
        )}
        {returnTotals.opd_refunds > 0 && (
            <div className="col-md-2 col-6">
                <div className="card border-danger h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-muted">OPD Refunds</small>
                        <h6 className="text-danger mb-0">- ₹{returnTotals.opd_refunds.toFixed(2)}</h6>
                    </div>
                </div>
            </div>
        )}
    </div>
)}

{/* Net Collection + Expenses + Net Amount */}
{filteredTransactions.length > 0 && (
    <div className="row mb-3 g-2">
        <div className="col-md-3 col-6">
            <div className="card bg-success text-white h-100">
                <div className="card-body text-center py-2">
                    <small className="text-white-50">Net Collection</small>
                    <h5 className="text-white mb-0">₹{filteredTotals.total.toFixed(2)}</h5>
                </div>
            </div>
        </div>
        <div className="col-md-3 col-6">
            <div className="card bg-danger text-white h-100">
                <div className="card-body text-center py-2">
                    <small className="text-white-50">Total Expenses</small>
                    <h5 className="text-white mb-0">- ₹{Number(expensesTotal).toFixed(2)}</h5>
                </div>
            </div>
        </div>
        <div className="col-md-3 col-6">
            <div className="card bg-dark text-white h-100">
                <div className="card-body text-center py-2">
                    <small className="text-white-50">Net Amount (In Hand)</small>
                    <h5 className="text-white mb-0">₹{Number(filteredTotals.total - expensesTotal).toFixed(2)}</h5>
                </div>
            </div>
        </div>
    </div>
)}
                           
                    </>
                )}

                {/* ============================================ */}
                {/* TAB 2: BALANCE SHEET (imported component)     */}
                {/* Independent — does NOT inherit Daybook dates  */}
                {/* ============================================ */}
                {activeTab === 'balance' && (
                    <BalanceSheet
                        onCountChange={setBalanceCount}
                    />
                )}

                {/* ============================================ */}
                {/* TAB 3: IPD NET COLLECTION                     */}
                {/* ============================================ */}
                {activeTab === 'ipd_net' && (
                    <IpdNetCollection
                        onCountChange={setIpdNetCount}
                    />
                )}
            </div>
        </div>
    );
}

export default Daybook;